module.exports = __webpack_public_path__ + "img/ic-start-edition.281b48a8.svg";